import { dataTvSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTvSolid = /*#__PURE__*/createIcon(dataTvSolid)
export default IconTvSolid
